module.exports = __webpack_public_path__ + "static/media/7-5.6c60ffe9.mp3";